module.exports = __webpack_public_path__ + "static/media/UIL_Region_20_Calendar_2025_2026_7_17_25.2aca962e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/UIL_Region_20_Calendar_2025_2026_7_17_25.pdf
// module id = 241
// module chunks = 0